import React from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { OSH_IMAGES } from "../../lib/worldOsharImages";
import { trackOsharRealEstateView } from "../../utils/analytics";

const OsharRealEstateCTA = () => {
  const bg = OSH_IMAGES.ctaRealEstate;

  return (
    <section className="oshar-cta" aria-labelledby="oshar-cta-heading">
      <div className="oshar-cta__bg" style={{ backgroundImage: `url(${bg})` }} />
      <div className="oshar-cta__veil" />
      <div className="oshar-inner oshar-cta__inner">
        <h2 id="oshar-cta-heading" className="oshar-cta__title">
          OWN YOUR PLACE IN OSHAR
        </h2>
        <p className="oshar-cta__lead">
          Secure parcels, towers, and storefronts that compound over seasons—unlock
          long-term benefits, guild visibility, and a permanent seat in the city’s
          economy as Treydora evolves.
        </p>
        <div className="oshar-cta__actions">
          <Link
            to="/world/oshar/real-estate"
            className="oshar-btn-gold"
            onClick={() =>
              trackOsharRealEstateView({
                cta_id: "world_real_estate_buy_vr_real_estate",
                section: "world_real_estate_cta",
                destination: "/world/oshar/real-estate",
              })
            }
          >
            BUY VR REAL ESTATE
          </Link>
          <HashLink
            smooth
            to="#oshar-what"
            className="oshar-btn-outline"
            onClick={() =>
              trackOsharRealEstateView({
                cta_id: "world_real_estate_learn_more",
                section: "world_real_estate_cta",
                destination: "#oshar-what",
              })
            }
          >
            LEARN MORE
          </HashLink>
        </div>
      </div>
    </section>
  );
};

export default OsharRealEstateCTA;
